import { Box, CircularProgress } from "@mui/material";
import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../data/providers/AuthProvider";
import { useUserData } from "../data/providers/UserDataProvider";

const PrivateRoute: React.FC = () => {
  const { user, loading } = useAuth();
  const data = useUserData();
  const location = useLocation();

  useEffect(() => {
    if (user) data?.reloadUserData();
  }, [user]);

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (!data?.data) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  const roles: string[] = data.data.role;
  const rolePaths = data.data.rolePaths;
  const userPaths: string[] = data.data.paths || [];
  const currentPath = location.pathname;

  const allowedFromRoles = roles.flatMap((r) => rolePaths[r] || []);

  const allowedRoutes = Array.from(
    new Set([...allowedFromRoles, ...userPaths])
  );
  allowedRoutes.push("/dashboard");

  const hasAccess = allowedRoutes.some((p) => currentPath.startsWith(p));

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
